import type PhinExceptionTypeKey from "mco-keys/src/t4/PhinExceptionTypeKey"
import { createSlice, PayloadAction } from "@reduxjs/toolkit/react"
import { useDispatch, useSelector } from "react-redux"
import { useCallback } from "react"

const initialPhinExceptions = {
	fileDateFilter: "",
	page: 0,
	pageSize: 10,
	episodeNumberFilter: "",
	exceptionTypeFilter: "" as string | PhinExceptionTypeKey
}

const phinExceptionsSlice = createSlice({
	name: "phinexceptions",
	initialState: initialPhinExceptions,
	reducers: {
		setFileDateFilter: (state, action: PayloadAction<string>) => {
			state.fileDateFilter = action.payload
		},
		setPage: (state, action: PayloadAction<number>) => {
			state.page = action.payload
		},
		setPageSize: (state, action: PayloadAction<number>) => {
			state.pageSize = action.payload
		},
		setEpisodeNumberFilter: (state, action: PayloadAction<string>) => {
			state.episodeNumberFilter = action.payload
		},
		setExceptionTypeFilter: (
			state,
			action: PayloadAction<string | PhinExceptionTypeKey>
		) => {
			state.exceptionTypeFilter = action.payload
		}
	},
	selectors: {
		fileDateFilter: (s) => s.fileDateFilter,
		page: (s) => s.page,
		pageSize: (s) => s.pageSize,
		episodeNumberFilter: (s) => s.episodeNumberFilter,
		exceptionTypeFilter: (s) => s.exceptionTypeFilter
	}
})

export const usePhinExceptionDateFilter = () => {
	const dispatch = useDispatch()
	const value =
		useSelector(phinExceptionsSlice.selectors.fileDateFilter) ?? ""
	const setValue = useCallback(
		(newValue: string) => {
			dispatch(phinExceptionsSlice.actions.setFileDateFilter(newValue))
		},
		[dispatch]
	)
	return [value, setValue] as const
}
export const usePhinExceptionTypeFilter = () => {
	const dispatch = useDispatch()
	const value =
		useSelector(phinExceptionsSlice.selectors.exceptionTypeFilter) ?? ""
	const setValue = useCallback(
		(newValue: string) => {
			dispatch(
				phinExceptionsSlice.actions.setExceptionTypeFilter(newValue)
			)
		},
		[dispatch]
	)
	return [value, setValue] as const
}
export const usePhinExceptionEpisodeNumberFilter = () => {
	const dispatch = useDispatch()
	const value =
		useSelector(phinExceptionsSlice.selectors.episodeNumberFilter) ?? ""
	const setValue = useCallback(
		(newValue: string) => {
			dispatch(
				phinExceptionsSlice.actions.setEpisodeNumberFilter(newValue)
			)
		},
		[dispatch]
	)
	return [value, setValue] as const
}

export default phinExceptionsSlice
